import { Option } from 'effect';

export type ListingHistoryLocation = {
  readonly pathname: string;
  readonly search: string;
};

export type ListingHistory = {
  readonly push: (href: string) => void;
  readonly location: () => ListingHistoryLocation;
  readonly subscribe: (onPop: () => void) => () => void;
};

/** Provides browser history access without requiring a browser during SSR. */
export const browserListingHistory: ListingHistory = {
  push: (href) =>
    Option.match(Option.fromNullishOr(globalThis.window), {
      onNone: () => {},
      onSome: (window) => window.history.pushState(null, '', href),
    }),
  location: () =>
    Option.match(Option.fromNullishOr(globalThis.window), {
      onNone: () => ({ pathname: '', search: '' }),
      onSome: (window) => ({ pathname: window.location.pathname, search: window.location.search }),
    }),
  subscribe: (onPop) =>
    Option.match(Option.fromNullishOr(globalThis.window), {
      onNone: () => () => {},
      onSome: (window) => {
        window.addEventListener('popstate', onPop);
        return () => window.removeEventListener('popstate', onPop);
      },
    }),
};
